import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { LoginReq } from '../models/LoginReq'
import { LoginRes } from '../models/LoginRes'
import { RequestRegistrationReq } from '../models/RequestRegistrationReq'
import { UserDataRes } from '../models/UserDataRes'
import { NewPasswordReq } from '../models/NewPasswordReq'
import { ChangePasswordReq } from '../models/ChangePasswordReq'

export const authenticate = (body : LoginReq) =>
AxiosInstance.post<LoginRes>(`${Config.gateway.authenticate}`,body)

export const getAccount = () =>
AxiosInstance.get(`${Config.gateway.account}`)

export const requestRegistration = (body: RequestRegistrationReq) =>
AxiosInstance.post<void>(`${Config.gateway.registration}`, body)

export const sendRecoveryPassMail = (body : string) =>
AxiosInstance.post<void>(`${Config.gateway.resetPasswordInit}`, body, {headers: {
    'Content-Type': 'text/html; charset=utf-8'}})

export const sendNewPassword = (body : NewPasswordReq) =>
AxiosInstance.post<void>(`${Config.gateway.resetPasswordFinish}`, body)

export const getUserData = (key : string) =>
AxiosInstance.get<UserDataRes>(`${Config.gateway.resetPassword}?key=` + key)

export const changePassword = (body : ChangePasswordReq) =>
AxiosInstance.post<void>(`${Config.gateway.changePassword}`, body)